export const tableHeaders = ["No", "Name"];

export const FORMS_BREADCRUMBS = [
  { id: "/", name: "Home" },
  { id: "/dynamic-forms", name: "Dynamic Forms" },
];
